module.exports = __webpack_public_path__ + "img/tw_permit_old.88b58d80.png";